import { render } from "./BillingSettings.vue?vue&type=template&id=b631b012&scoped=true"
import script from "./BillingSettings.vue?vue&type=script&lang=js"
export * from "./BillingSettings.vue?vue&type=script&lang=js"

import "./BillingSettings.vue?vue&type=style&index=0&id=b631b012&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b631b012"]])

export default __exports__